import { useLogout } from '@core/hooks/useLogout'
import { ROUTES } from '@platform/router/paths'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { useCallback } from 'react'

const cognitoDomain = import.meta.env.VITE_COGNITO_DOMAIN

export const Route = createFileRoute('/logout')({
  component: LogoutPage,
})

function LogoutPage() {
  const navigate = useNavigate()

  useLogout({
    cognitoDomain,
    onNonSsoLogout: useCallback(
      () => navigate({ to: ROUTES.signIn, viewTransition: false }),
      [navigate]
    ),
  })

  return null
}
